
  import { Vue, Component, Prop } from "vue-property-decorator";
  import RemoveManagerContractorRequest from "@/components/contractors/RemoveManagerContractorRequestNew.vue";
  import AddContractorToCompany from "@/components/contractors/AddContractorToCompanyNew.vue";

  @Component({
    components: {
      AddContractorToCompany,
      RemoveManagerContractorRequest,
    },
  })
  export default class ManagerAccessActions extends Vue {
    @Prop({ type: String, required: true }) readonly companyName!: string;
    @Prop({ type: String, required: true }) readonly companyId!: string;
    @Prop({ type: String, required: true }) readonly contractorUserId!: string;
    @Prop({ type: String, required: true }) readonly currentUserId!: string;
    @Prop({ type: String, required: true }) readonly managerId!: string;
    @Prop({ type: String, default: undefined }) readonly contractorId!: string;
    @Prop({ type: Boolean, default: false }) readonly isRequestContractorShown!: boolean;
    @Prop({ type: Boolean, default: false }) readonly isContractorRequested!: boolean;
    @Prop({ type: Boolean }) readonly isPublic!: boolean;
  }
